<template>
    <Monthlive/>
</template>

<script>
import { Monthlive } from 'shared'

export default {
    name: 'monthlive',
    components: {
        Monthlive
    },
    data() {
        return {
            params: {
                main: 11,
                sub: 76,
            }
        }
    },
    created() {
        this.$store.commit('getMonth', this.params)
    },
}
</script>